/* MXDVS collections list (/collections), 30.09.2026
   v4: a switch puts the new photo in place at once under the finished ASCII and hides the previous one
   at once, then only the ASCII fades, so the previous photo never shows between the ASCII and the new one.
   v3: every tile holds the newest products of its collection and switches between them on its own,
   each tile at its own random moment, with a new ASCII effect typed over the current photo. Tiles only
   switch while on screen and while the tab is open; the next photo loads just before its switch.
   The typed text under the title has no cursor.
   Section: sections/mxdvs-collections-list.liquid. Styles: assets/mxdvs-collections-list.css.
   - ASCII arrival: when a tile comes into view, its photo is typed out in terminal characters line by
     line, holds as ASCII art, then develops into the real photo. Every drawing is deleted afterwards,
     so phones keep no extra memory. Tiles arriving together follow each other with a small delay.
   - The terminal path links, the collection name and "> open collection" decode on hover.
   Respects reduced motion (no switching, no ASCII). */
(function () {
  if (window.MxCollectionsList) return;

  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#%/<>';
  var RAMP = '@%#*+=-:. ';
  var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function reduce() { return reduceMq.matches; }
  function num(el, k, d) { var v = parseFloat(el.getAttribute(k)); return isNaN(v) ? d : v; }

  function decode(el, text, ms) {
    if (!el) return;
    if (el._mxlDec) cancelAnimationFrame(el._mxlDec);
    if (reduce()) { el.textContent = text; return; }
    var t0 = performance.now();
    (function step(now) {
      var k = Math.min(1, (now - t0) / ms), out = '';
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        out += (ch === ' ' || i / text.length < k) ? ch : GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
      }
      el.textContent = out;
      if (k < 1) el._mxlDec = requestAnimationFrame(step);
    })(t0);
  }

  /* Typed text under the title, no cursor. Its full height is kept from the start, so the collection
     count next to it stays level with the last line while the text types. */
  function typeText(el) {
    var text = el.getAttribute('data-mxl-type') || '';
    if (!text || reduce()) return;
    el.style.minHeight = el.offsetHeight + 'px';
    var i = 0;
    (function step() {
      el.textContent = text.slice(0, i);
      if (i++ < text.length) setTimeout(step, 18 + Math.random() * 40);
    })();
  }

  /* A photo that is not shown yet keeps its address in data-src until it is needed */
  function load(img) {
    if (!img) return Promise.resolve();
    if (!img.getAttribute('src') && img.dataset.src) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
    }
    return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
  }

  /* Brightness grid of the photo, from a small copy */
  function sample(url, cols, rows) {
    return new Promise(function (resolve) {
      if (!url) { resolve(null); return; }
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width = cols; c.height = rows;
          var x = c.getContext('2d');
          /* cover crop, like the photo in the tile */
          var ir = im.width / im.height, cr = cols / (rows * 1.62);
          var sw = im.width, sh = im.height, sx = 0, sy = 0;
          if (ir > cr) { sw = im.height * cr; sx = (im.width - sw) / 2; } else { sh = im.width / cr; sy = (im.height - sh) / 2; }
          x.fillStyle = '#fff'; x.fillRect(0, 0, cols, rows);
          x.drawImage(im, sx, sy, sw, sh, 0, 0, cols, rows);
          var d = x.getImageData(0, 0, cols, rows).data, out = [];
          for (var i = 0; i < cols * rows; i++) {
            var l = (0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2]) / 255;
            out.push(RAMP[Math.min(RAMP.length - 1, Math.floor(l * RAMP.length))]);
          }
          c.width = c.height = 0;
          resolve(out);
        } catch (e) { resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = url;
    });
  }

  /* Types the photo `to` out in characters. Arrival: on the canvas that covers the tile.
     Switch: on a new see-through canvas, line by line over the current photo. */
  function ascii(root, li, to, arrival, done) {
    var media = li.querySelector('.mxl-media');
    var cv = arrival ? li.querySelector('.mxl-ascii') : null;
    if (!cv) {
      cv = document.createElement('canvas');
      cv.className = 'mxl-ascii mxl-ascii--swap';
      cv.setAttribute('aria-hidden', 'true');
      media.appendChild(cv);
    }
    var desk = window.matchMedia('(min-width: 990px)').matches;
    var ch = Math.max(5, desk ? num(root, 'data-cell', 10) : num(root, 'data-cell-m', 7));
    var W = media.clientWidth, H = media.clientHeight, dpr = Math.min(2, window.devicePixelRatio || 1);
    var cw = ch * 0.62, cols = Math.ceil(W / cw), rows = Math.ceil(H / ch);
    var ink = root.getAttribute('data-ink') || '#000', bg = root.getAttribute('data-bg') || '#f2f2f2';
    var typeMs = num(root, 'data-type-ms', 1100), band = Math.max(1, num(root, 'data-band', 5)), hold = num(root, 'data-hold', 500);

    sample(to && to.getAttribute('data-ascii'), cols, rows).then(function (grid) {
      if (!grid) { grid = []; for (var i = 0; i < cols * rows; i++) grid.push(RAMP[Math.floor(Math.random() * RAMP.length)]); }
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      var x = cv.getContext('2d');
      x.scale(dpr, dpr);
      x.font = '400 ' + ch + 'px "Roboto Mono", ui-monospace, Menlo, Consolas, monospace';
      x.textBaseline = 'top';
      if (arrival) { x.fillStyle = bg; x.fillRect(0, 0, W, H); }
      function row(r, scrambled) {
        x.fillStyle = bg; x.fillRect(0, r * ch, W, ch);
        x.fillStyle = ink;
        for (var c = 0; c < cols; c++) {
          var g = grid[r * cols + c];
          if (g === ' ') continue;
          if (scrambled) g = GLYPHS[Math.floor(Math.random() * GLYPHS.length)];
          x.fillText(g, c * cw, r * ch);
        }
      }
      var settled = 0, t0 = performance.now();
      (function step(now) {
        var k = Math.min(1, (now - t0) / typeMs), head = Math.floor(k * (rows + band));
        while (settled < rows && settled < head - band) row(settled++, false);
        for (var r = Math.max(settled, head - band); r < Math.min(rows, head); r++) row(r, true);
        if (settled < rows) { requestAnimationFrame(step); return; }
        /* Hold as ASCII, then develop into the photo once it has loaded */
        Promise.all([load(to), new Promise(function (res) { setTimeout(res, hold); })]).then(function () { done(cv); });
      })(t0);
    });
  }

  function init(root) {
    if (!root || root._mxl) return;
    root._mxl = true;
    root.querySelectorAll('[data-mxl-type]').forEach(typeText);
    root.querySelectorAll('.mxc-path a').forEach(function (a) {
      var text = a.textContent;
      a.addEventListener('mouseenter', function () { decode(a, text, 400); });
    });

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mxl-item]'));
    var anim = root.classList.contains('mxl-anim');
    var still = reduce();
    var fade = num(root, 'data-fade', 900), gap = num(root, 'data-gap', 150);
    var cycle = root.getAttribute('data-cycle') === 'true' && !still;
    var tMin = num(root, 'data-cycle-min', 6), tMax = Math.max(tMin, num(root, 'data-cycle-max', 14));

    items.forEach(function (li) {
      li._imgs = Array.prototype.slice.call(li.querySelectorAll('.mxl-img'));
      li.querySelector('.mxl-tile').addEventListener('mouseenter', function () {
        var t = li.querySelector('.mxl-title [data-decode]'), go = li.querySelector('.mxl-go');
        if (t) decode(t, t.getAttribute('data-decode'), 450);
        if (go) decode(go, go.getAttribute('data-decode'), 450);
      });
      /* Tiles below the first row start on a random one of their photos */
      if (cycle && li._imgs.length > 1 && !li.hasAttribute('data-first-row')) {
        var first = li._imgs[0], pick = li._imgs[Math.floor(Math.random() * li._imgs.length)];
        if (pick !== first) {
          first.dataset.src = first.getAttribute('src'); first.removeAttribute('src');
          first.dataset.srcset = first.getAttribute('srcset') || ''; first.removeAttribute('srcset');
          first.classList.remove('is-on');
          pick.classList.add('is-on');
          pick.setAttribute('loading', 'lazy');
          if (pick.dataset.srcset) pick.srcset = pick.dataset.srcset;
          pick.src = pick.dataset.src;
        }
      }
    });

    function current(li) { return li.querySelector('.mxl-img.is-on'); }
    /* snap: the ASCII covers the whole tile, so the new photo goes in place at once underneath and the
       previous photo is hidden at once; only the ASCII fades away. Without snap (arrival, or switches
       without ASCII) the photos fade. */
    function show(li, to, cv, snap) {
      var media = li.querySelector('.mxl-media');
      if (snap) media.classList.add('is-snap');
      li._imgs.forEach(function (im) { im.classList.toggle('is-on', im === to); });
      if (snap) { void media.offsetWidth; requestAnimationFrame(function () { media.classList.remove('is-snap'); }); }
      if (cv) {
        cv.classList.add('is-out');
        setTimeout(function () { cv.width = cv.height = 0; cv.remove(); }, fade + 100);
      }
    }

    /* Each tile switches to another of its photos at its own random moment, only while it is on screen */
    function schedule(li) {
      if (!cycle || li._imgs.length < 2) return;
      clearTimeout(li._mxlT);
      li._mxlT = setTimeout(function () {
        if (document.hidden || !li._vis) { schedule(li); return; }
        var now = current(li), others = li._imgs.filter(function (im) { return im !== now; });
        var to = others[Math.floor(Math.random() * others.length)];
        load(to).then(function () {
          if (anim) ascii(root, li, to, false, function (cv) { show(li, to, cv, true); schedule(li); });
          else { show(li, to, null); schedule(li); }
        });
      }, (tMin + Math.random() * (tMax - tMin)) * 1000);
    }

    function arrive(li) {
      li.classList.add('is-in');
      var t = li.querySelector('.mxl-title [data-decode]');
      if (t) decode(t, t.getAttribute('data-decode'), 600);
      var to = current(li);
      ascii(root, li, to, true, function (cv) { li.classList.add('is-done'); show(li, to, cv); schedule(li); });
    }

    /* Which tiles are on screen right now (for switching) */
    if ('IntersectionObserver' in window) {
      var vis = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.closest('[data-mxl-item]')._vis = e.isIntersecting; });
      }, { threshold: 0.2 });
      items.forEach(function (li) { vis.observe(li.querySelector('.mxl-media')); });
    } else items.forEach(function (li) { li._vis = true; });

    if (!anim || still || !('IntersectionObserver' in window)) {
      items.forEach(function (li) { li.classList.add('is-in', 'is-done'); schedule(li); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.filter(function (e) { return e.isIntersecting; })
        .sort(function (a, b) { return (a.boundingClientRect.top - b.boundingClientRect.top) || (a.boundingClientRect.left - b.boundingClientRect.left); })
        .forEach(function (e, k) {
          io.unobserve(e.target);
          var li = e.target.closest('[data-mxl-item]');
          setTimeout(function () { arrive(li); }, k * gap);
        });
    }, { threshold: 0.3, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (li) { io.observe(li.querySelector('.mxl-media')); });
  }

  function boot() { document.querySelectorAll('[data-mxl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-mxl]');
    if (r) init(r);
  });
  window.MxCollectionsList = { init: init };
})();
